function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 18 18",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    }
  }, props), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 18.013,
    height: 18.013,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.472,3.567l-11.232,12.435l-5.698,-6.305l1.722,-1.557l3.976,4.399l9.509,-10.528c0.574,0.519 1.148,1.037 1.723,1.556Z",
    style: {
      fillRule: "nonzero"
    }
  }));
};
export default SvgCheckmark;